import { render, staticRenderFns } from "./KantorSwitcher.vue?vue&type=template&id=63a61715"
import script from "./KantorSwitcher.vue?vue&type=script&lang=js"
export * from "./KantorSwitcher.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports